import { render, staticRenderFns } from "./AreaKoordinatorInfo.vue?vue&type=template&id=7013efe0&scoped=true"
import script from "./AreaKoordinatorInfo.vue?vue&type=script&lang=js"
export * from "./AreaKoordinatorInfo.vue?vue&type=script&lang=js"
import style0 from "./AreaKoordinatorInfo.vue?vue&type=style&index=0&id=7013efe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7013efe0",
  null
  
)

export default component.exports